<template>
    <ui-float-dropdown class="w-fit">
        <template #reference>
            <Button color="secondary" size="sm" type="button">
                <icon icon="phosphor/regular/calendar-plus" class="size-4 mr-1" />
                {{ lang('calendar.actions.add_to_calendar') }}
            </Button>
        </template>

        <ui-popover-section>
            <ui-popover-segment>
                <ui-popover-link :a="true" :href="exportUrl('google')" target="_blank">
                    <icon icon="phosphor/regular/google-logo" class="size-4 mr-1" />
                    <span>{{ lang('calendar.calendars.google') }}</span>
                </ui-popover-link>
                <ui-popover-link :a="true" :href="exportUrl('outlook')" target="_blank">
                    <icon icon="phosphor/regular/microsoft-outlook-logo" class="size-4 mr-1" />
                    <span>{{ lang('calendar.calendars.outlook') }}</span>
                </ui-popover-link>
                <ui-popover-link :a="true" :href="exportUrl('ics')">
                    <icon icon="phosphor/regular/download-simple" class="size-4 mr-1" />
                    <span>{{ lang('calendar.calendars.download_ics') }}</span>
                </ui-popover-link>
            </ui-popover-segment>
        </ui-popover-section>
    </ui-float-dropdown>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
    title: string;
    description?: string;
    start: string;
    end: string;
    location?: string;
    url?: string;
    timezone?: string;
}

const props = withDefaults(defineProps<Props>(), {
    description: '',
    location: '',
    url: '',
    timezone: 'Europe/Prague',
});

const baseParams = computed(() => {
    const params: Record<string, string> = {
        title: props.title,
        start: props.start,
        end: props.end,
    };

    const description = props.description.replace(/<[^>]*>/g, '');

    if (description) {
        params.description = description;
    }

    if (props.location) {
        params.location = props.location;
    }

    if (props.url) {
        params.url = props.url;
    }

    if (props.timezone) {
        params.timezone = props.timezone;
    }

    return params;
});

const exportUrl = (type: string): string => {
    const params = new URLSearchParams(baseParams.value);

    return route('calendar.export', { type }) + '?' + params.toString();
};
</script>
